import { toast } from 'react-toastify'
import './toast.css'

function ToastsSuccess(message) {
  return (
    toast.success(message, {
      position: "top-center",
      autoClose: 1500,
      margin:50,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
    })
  )
}
function ToastsSuccessWithTime(message, time) {
  return (
    toast.success(message, {
      position: "top-center",
      autoClose: time,
      margin:50,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
    })
  )
}
function ToastsError(message) {
  return (
    toast.error(message, {
      position: "top-center",
      margin:"10%",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0
    })
  )
}

function ToastsErrorWithTime(message, time) {
  return (
    toast.error(message, {
      position: "top-center",
      margin:"10%",
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0
    })
  )
}

export {ToastsSuccess, ToastsError, ToastsSuccessWithTime, ToastsErrorWithTime}